var render = function render(){var _vm=this,_c=_vm._self._c;return _c('list-table',{attrs:{"url":_vm.url,"title":"گزارش سوییچ","fields":_vm.fields,"params":_vm.params}})
}
var staticRenderFns = []

export { render, staticRenderFns }